import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from "@components/Layout/Layout";
import { About } from "@components/Pages/About/About";
export default function AboutPage() {
    return /*#__PURE__*/ _jsx(Layout, {
        pageTitle: "About",
        metaDescription: "Hello, I'm Michal \uD83D\uDC4B I am the founder, engineer, designer and customer support of Jobs in JS.",
        bodyCN: "px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-4xl m-auto",
            children: /*#__PURE__*/ _jsx("div", {
                className: "pt-10 pb-20",
                children: /*#__PURE__*/ _jsx(About, {})
            })
        })
    });
}
